import React from 'react';
import { CreateCategoryForm } from '../../modules';
import { routePaths } from '../../routePaths';
import { EditScreenLayout } from '../../ui-kit';

const CategoryCreate = () => (
    <EditScreenLayout path={routePaths.categories}>
        <CreateCategoryForm />
    </EditScreenLayout>
);

export default CategoryCreate;
